import useTranslator from "../../hooks/useTranslator";

const ProcessFailedModal = ({
  showPopup,
  isGuarantor,
  heading,
  subheading,
  closeModalState,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      {showPopup && (
        <div
          className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
            isGuarantor ? "guarantorBg" : ""
          }`}
        >
          <div className="popup-content2 popup-content bg-white kycDonePopup">
            <div className="row relativeposition custom-mb-5">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
                <div className="authenticateid-header text-center">
                  <h4>{heading}</h4>
                  <p>{subheading}</p>
                </div>
              </div>
            </div>
            <div className="text-center py-3 custom-mb-5">
              <div className="animate-slow-bounce">
                <div className="circle-container">
                  {/* 'X' Cross */}
                  <div className="x-wrapper">
                    {/* First bar of 'X' */}
                    <div className="x-bar rotate"></div>
                    {/* Second bar of 'X' */}
                    <div className="x-bar reverse-rotate"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <button
                type="button"
                className="btnNext btnnextpre uploadbtn go_back_btn full_radius custom-mb-3"
                onClick={(e) => closeModalState(false)}
              >
                {_t("goBackAndReupload")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProcessFailedModal;
